// extracted by mini-css-extract-plugin
export default {"header":"index_header__f84oe","headertag":"index_headertag__-04Zs","modaltitle":"index_modaltitle__28Fw4","beautifystyle":"index_beautifystyle__isrqL","switch":"index_switch__qjgFC"};